import { promiseLandConstants } from "./constants/promiseLandConstant";

const promiseLandSave = (promiseLandInput: any) => {
	return {
		type: promiseLandConstants.PromiseLandSaveRequest,
		input: promiseLandInput
	};
};

const promiseLandGetByFilter = (data:any) => {
	return {
		type: promiseLandConstants.PromiseLand_GetByFilter_Request,
		input: data
	};
};
 
const promiseLandGetDetail = (id: any) => {
	return {
		type: promiseLandConstants.PromiseLandDetailRequest,
		input: id
	};
};

const promiseLandGetBooks = () => {
	return {
		type: promiseLandConstants.PromiseLandGetBooksRequest,
	};
};

const promiseLandDelete = (id: any) => {
	return {
		type: promiseLandConstants.PromiseLandDeleteRequest,
		input: id
	};

};

export const promiseLandAction = {
	promiseLandGetByFilter,
	promiseLandGetDetail,
	promiseLandGetBooks,
	promiseLandSave,
	promiseLandDelete
};